/** Khớp với segment URL `/admin/settings/:section` */
export const SETTINGS_SECTION_IDS = ["global", "about", "areas"];

export const SETTINGS_SECTION_HEAD = {
  global: {
    title: "Cài đặt chung",
    subtitle: "Logo, favicon, thông tin liên hệ, mạng xã hội, SEO mặc định và analytics.",
  },
  about: {
    title: "Giới thiệu",
    subtitle: "Nội dung và SEO trang Giới thiệu.",
  },
  areas: {
    title: "Khu vực (trang public)",
    subtitle: "Ảnh nền hero trang danh sách khu vực.",
  },
};
